/**
 * Wheel Configurator View
 * ------------------------------------------------------------------------------
 * A script to load the view for the wheel configurator.
 * This uses JS & Data attributes to switch between each step using CSS to display block/none the elements.
 *
 * @namespace wheelConfigView
 */
import log from 'salvo-lite/log'

import {on} from '../../helpers/utils'
import cssClasses from '../../helpers/cssClasses'
import breakpoints from '../../helpers/breakpoints'

class WcTyres {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            changeStepButton: '[js-show-form-step]',
            formContainer: '[js-wheel-config-form]',
            headerContainer: '[js-site-header=container]',
            sliderContent: '[js-car-slider=container]',
            wheelConfigCarousel: '[js-carousel]',
            wheelConfigContainer: '[js-current-step]',
            wheelConfigContent: '[js-wheel-config-content]',
            ...JSON.parse(elem.getAttribute('data-wc-view') || '{}')
        }

        /**
         * Node selectors.
         */
        this._nodeSelectors = {
            changeStepButton: document.querySelectorAll(this._settings.changeStepButton),
            formContainer: document.querySelector(this._settings.formContainer),
            headerContainer: document.querySelector(this._settings.headerContainer),
            sliderContent: document.querySelector(this._settings.sliderContent),
            wheelConfigCarousel: document.querySelectorAll(this._settings.wheelConfigCarousel),
            wheelConfigContainer: document.querySelector(this._settings.wheelConfigContainer),
            wheelConfigContent: document.querySelector(this._settings.wheelConfigContent)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise accordion component.
     */
    onInit () {
        this._setListeners()
        this._setClickEvents()
    }

    /**
     * Set listeners for the event bus
     */
    _setListeners () {
        window.Frame.EventBus.listen('WheelConfig:tyresLoaded', () => {
            this._showContent()
            this._initCarousels()
        })
        window.Frame.EventBus.listen('WheelConfig:stepChange', (response) => this._showStep(response))
        window.Frame.EventBus.listen('WheelConfig:formActive', () => {
            this._makeFormSticky()
        })
        window.Frame.EventBus.listen('WheelConfig:optionChanged', () => this._scrollCarIntoView())
    }

    /**
     * Set clickable events
     */
    _setClickEvents () {
        this._nodeSelectors.changeStepButton.forEach((item) => {
            on('click', item, () => {
                window.Frame.EventBus.emit('WheelConfig:stepChange', item)
            })
        })
    }

    /**
     * Show the step of the wheel configuator that matches the selected buttons step attribute
     * @param {Object} item selected button node
     */
    _showStep (item) {
        // Set the variable to equal the selected button JS attribute
        const showView = item.getAttribute('js-show-form-step')

        // Change the value on the parent to decide which elements are shown/hidden using CSS
        this._nodeSelectors.wheelConfigContainer.setAttribute('js-current-step', showView)

        this._updateCarousel(showView)
    }

    /**
     * Show the content once all the data has been loaded
     */
    _showContent () {
        this._nodeSelectors.sliderContent.classList.remove(cssClasses.loading)
    }

    /**
     * Initialise both carousels once tyresLoaded event has been emitted
     */
    _initCarousels () {
        this._nodeSelectors.wheelConfigCarousel.forEach((carousel, index) => {
            const item = carousel.querySelector('[js-carousel-item]').getAttribute('js-carousel-item')
            this._carouselOptions.cellSelector = `[js-carousel-item=${item}]`
            this._wheelConfigCarousel[index] = this._theme.getComponentsById('config-tyre-carousel')._carousel
        })
    }

    /**
     * Update the matching carousel based on which step is active
     * @param {string} step the step attached to the button
     */
    _updateCarousel (step) {
        if (step === 'start' || step === 'colour') {
            this._wheelConfigCarousel[0].resize()
        } else if (step === 'wheel') {
            this._wheelConfigCarousel[1].resize()
        }
    }

    /**
     * When mobile form starts, make the form sticky
     */
    _makeFormSticky () {
        this._nodeSelectors.formContainer.classList.add(cssClasses.sticky)
    }

    /**
     * Scroll the car slider image into view when changing colour options
     */
    _scrollCarIntoView () {
        if (window.matchMedia(`(min-width: ${breakpoints.medium})`).matches) {
            return
        }

        const carPos = ((this._nodeSelectors.sliderContent.offsetTop + this._nodeSelectors.sliderContent.clientHeight) - (window.innerHeight - this._nodeSelectors.formContainer.clientHeight))
        window.scroll({
            top: carPos,
            left: 0,
            behavior: 'smooth'
        })
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // });
}

export default WcTyres



// WEBPACK FOOTER //
// ./src/resources/scripts/components/wheel-config/WcView.js